<div class="border rounded p-2 mb-2 bg-light-subtle">
  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
    <h6 class="mb-0">
      Barcodes
      <small class="text-muted fw-normal">— every active code scans; the primary one is what lists, labels and reports show. Pricing is separate (below).</small>
    </h6>
    @if (loading) {
      <span class="spinner-border spinner-border-sm"></span>
    }
  </div>

  @if (!variantId) {
    <div class="text-muted small">Save the product first, then tag its barcodes here (or on the Bulk EAN grid).</div>
  } @else {
    @if (active.length) {
      <ul class="list-unstyled mb-2">
        @for (b of active; track trackById($index, b)) {
          <li class="d-flex align-items-center gap-2 py-1">
            @if (editingId === b.id) {
              <div class="input-group input-group-sm" style="max-width: 360px">
                <input
                  type="text"
                  class="form-control"
                  maxlength="64"
                  [(ngModel)]="editCode"
                  [ngModelOptions]="{ standalone: true }"
                  (keydown.enter)="$event.preventDefault(); saveEdit(b)"
                  (keydown.escape)="cancelEdit()"
                  autocomplete="off"
                  autofocus
                />
                <button type="button" class="btn btn-primary" [disabled]="busy || !editCode.trim()" (click)="saveEdit(b)">
                  Save
                </button>
                <button type="button" class="btn btn-outline-secondary" [disabled]="busy" (click)="cancelEdit()">
                  Cancel
                </button>
              </div>
            } @else {
              <code class="fs-6">{{ b.code }}</code>
              @if (b.isPrimary) {
                <span class="badge text-bg-primary" title="Shown on lists and printed on labels">primary</span>
              } @else {
                <button type="button" class="btn btn-link btn-sm p-0" [disabled]="busy" (click)="setPrimary(b)">
                  make primary
                </button>
              }
              <span class="text-muted small ms-auto">{{ b.source | lowercase }}</span>
              <button
                type="button"
                class="btn btn-link btn-sm p-0 text-secondary"
                [disabled]="busy"
                title="Edit this barcode (replaces it)"
                (click)="startEdit(b)"
              >
                <i class="bi bi-pencil"></i>
              </button>
              <button
                type="button"
                class="btn btn-link btn-sm p-0 text-danger"
                [disabled]="busy"
                title="Remove this barcode from the SKU"
                (click)="retire(b)"
              >
                <i class="bi bi-x-circle"></i>
              </button>
            }
          </li>
        }
      </ul>
    } @else if (!loading) {
      <div class="text-warning-emphasis small mb-2">
        <i class="bi bi-exclamation-triangle-fill me-1"></i>No barcode yet — this SKU cannot be scanned.
      </div>
    }

    <div class="input-group input-group-sm" style="max-width: 420px">
      <input
        type="text"
        class="form-control"
        placeholder="Add EAN / barcode"
        maxlength="64"
        [(ngModel)]="newCode"
        [ngModelOptions]="{ standalone: true }"
        (keydown.enter)="$event.preventDefault(); add()"
        autocomplete="off"
      />
      <button type="button" class="btn btn-primary" [disabled]="busy || !newCode.trim()" (click)="add()">
        Add
      </button>
    </div>

    @if (retired.length) {
      <button type="button" class="btn btn-link btn-sm p-0 mt-2" (click)="showRetired = !showRetired">
        {{ showRetired ? "Hide" : "Show" }} {{ retired.length }} retired
      </button>
      @if (showRetired) {
        <ul class="list-unstyled mb-0 small text-muted">
          @for (b of retired; track trackById($index, b)) {
            <li><s>{{ b.code }}</s></li>
          }
        </ul>
      }
    }
  }
</div>
